import { render } from "./square.vue?vue&type=template&id=3eadbbf6&scoped=true"
import script from "./square.vue?vue&type=script&lang=js"
export * from "./square.vue?vue&type=script&lang=js"

import "./square.vue?vue&type=style&index=0&id=3eadbbf6&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eadbbf6"]])

export default __exports__